import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initClarity, mustReloadWithoutClarity } from '../lib/clarity';

// Clarity must never record a team page (src/lib/clarity.js). When an in-app
// navigation reaches one in a document that already loaded Clarity, render
// nothing and reload: the console then opens in a fresh document, where
// initClarity() refuses to load. Leaving a team page for a public one loads
// Clarity at that point.
export default function ClarityGuard({ children }) {
  const { pathname } = useLocation();
  const reload = mustReloadWithoutClarity(pathname);
  useLayoutEffect(() => { if (reload) window.location.reload(); }, [reload, pathname]);
  useEffect(() => { initClarity(pathname); }, [pathname]);
  if (reload) return <div data-clarity-guard="reloading" />;
  return children;
}
